import LocalCanResolver from "../../imagine/dataSource/LocalCanResolver.js";
/**
 * Creates an initializer and provider creator for Api
 */
export default {
  id: 'molten.LocalCanResolverInit',
  sort: -100,
  init: molten => {
    return LocalCanResolver.init({
      molten
    });
  }
};